<template>
  <div
    v-loading.fullscreen.lock="uploadLoading"
    class="ccui-multifunctional-table-wrapper ccui-multifunctional-table-wrapper-detail"
  >
    <template v-if="type != 2">
      <div class="operate">
        <el-upload
          class="upload-demo tow"
          :data="formData"
          :action="uploadForm.action"
          :before-upload="beforeAvatarUpload"
          :on-success="uploadSuccess"
          :show-file-list="false"
          :on-error="uploadError"
          :on-progress="onProgress"
          :headers="uploadForm.headers"
          multiple
        >
          <el-button plain type="single-number">上传附件</el-button>
        </el-upload>
      </div>
      <div class="clearfix"></div>
    </template>
    <el-table
      :data="fileTableData"
      border
      class="dic-sub-table-style01"
      :style="this.$route.query.type === 'add' ? '' : 'margin-top:20px'"
    >
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column
        prop="fileName"
        label="附件名称"
        show-overflow-tooltip
        width="180"
      ></el-table-column>
      <el-table-column
        prop="fileSize"
        label="附件大小"
        show-overflow-tooltip
        width="100"
      >
        <template slot-scope="{ row }"> {{ row.fileSize }}kb </template>
      </el-table-column>
      <el-table-column prop="fileSumm" label="附件说明" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="type != 2 && fileSummType != 1">
            <el-input
              v-model="scope.row.fileSumm"
              placeholder="请输入附件说明"
              maxlength="415"
              show-word-limit
            />
          </template>
          <template v-else>{{ scope.row.fileSumm }}</template>
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="上传时间"
        show-overflow-tooltip
        :width="dateTimeWidth"
      ></el-table-column>
      <el-table-column type="action" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="download(scope.$index, scope.row)"
            >下载</el-button
          >
          <!--          <el-button type="text" @click="downloadUrlFile(scope.row)"-->
          <!--            >下载</el-button-->
          <!--          >-->
          <template v-if="type == 2">
            <el-button type="text" @click="preview(scope.row)">预览</el-button>
          </template>
          <template v-if="type != 2">
            <el-button type="text" @click="deleteRow(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!--- 上传附件填写基本信息 -->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { pageTableWidth } from "@/setting/setting";
import { addUrlPerFix, getPreviewUrl } from "@/basa/utils";
import {
  delFileInfo
  // savefile
} from "@/app/sourcingFlow/api/expertEvaluation.js";

export default {
  name: "attachmentUpload",
  props: {
    fileData: {
      type: Array,
      default() {
        return [];
      }
    },
    // id: {
    //   type: String, // 编辑、复制、查看详情
    //   default: ""
    // },
    type: {
      type: Number, // 0：编辑、新增 1:复制 2： 查看详情
      default: 0
    },
    fileSummType: {
      type: Number, // 1 只能查看
      default: 0
    },
    isMultipleFlag: {
      //是否多文件上传标识
      type: Boolean,
      default: false
    }
  },
  watch: {
    fileData(val) {
      console.log(val);
      this.fileTableData = val;
    }
  },
  data() {
    return {
      dateTimeWidth: pageTableWidth.dateTimeWidth,
      uploadForm: {
        action: this.$addUrlPerFix(
          process.env.VUE_APP_BASE_URL + "/apis/bid/oss/uploadFilePersNew"
        ),
        headers: {
          Authorization: Cookies.get("access_token") || ""
        }
      },
      formData: {
        agentId: this.$router.history.current.query.a
      },
      fileTableData: this.fileData,
      uploadLoading: false,
      deletePlanAttachementList: [] // 删除的数据
    };
  },
  deactivated() {
    this.fileTableData = [];
    this.deletePlanAttachementList = [];
    this.uploadLoading = false;
  },
  methods: {
    async uploadSuccess(res, file, fileList) {
      console.log(res);
      let fileData = res.data[0];
      fileData.downloadUrl = fileData.ossUrl;
      // await savefile({ uploadIds: fileData.uploadId }).then(obj => {
      //   fileData.downloadUrl = obj.data.data.fileInfoList[0].ossUrl;
      // });
      this.uploadLoading = false;
      let fileNameDuplication = false;
      if (this.fileTableData && this.fileTableData.length > 0) {
        this.fileTableData.forEach(item => {
          if (fileData.fileName == item.fileName) {
            fileNameDuplication = true;
          }
        });
      }
      if (fileNameDuplication) {
        this.$message({
          message: "请不要上传重名附件，请编辑后重新上传",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData.uploadId) {
        this.$message({
          message: "上传ID不能为空！请重新上传文件",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      } else if (!fileData.downloadUrl) {
        this.$message({
          message: "文件URL不能为空！请重新上传文件",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        return false;
      }
      this.$message.success("附件上传成功");
      let obj = {
        fileUrl: fileData.downloadUrl,
        fileName: fileData.fileName,
        fileSize: Math.round(fileData.fileSize / 1024),
        fileSumm: "",
        createTime: fileData.createTime,
        fileinfoType: fileData.fileType,
        uploadId: fileData.uploadId
      };
      if (this.isMultipleFlag) {
        this.fileTableData = [obj];
      } else {
        this.fileTableData.push(obj);
      }
    },
    uploadError(err, file, fileList) {
      this.$message({
        message: err.message,
        type: "error",
        duration: 3000,
        showClose: true,
        ccuiCustom: true
      });
      this.uploadLoading = false;
    },
    onProgress(event, file, fileList) {
      this.uploadLoading = true;
    },
    beforeAvatarUpload(file) {
      console.log(file);
      this.uploadLoading = true;
      const isLt50 = file.size < 52428800;
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension =
        testmsg === "xlsx" ||
        testmsg === "xls" ||
        testmsg === "XLSX" ||
        testmsg === "XLS" ||
        testmsg === "doc" ||
        testmsg === "docx" ||
        testmsg === "ppt" ||
        testmsg === "pptx" ||
        testmsg === "pdf" ||
        testmsg === "jpg" ||
        testmsg === "png" ||
        testmsg === "txt" ||
        testmsg === "rft" ||
        testmsg === "msg" ||
        testmsg === "wps" ||
        testmsg === "et" ||
        testmsg === "dps" ||
        testmsg === "vsd" ||
        testmsg === "prn" ||
        testmsg === "ai" ||
        testmsg === "cad" ||
        testmsg === "JPG" ||
        testmsg === "PNG" ||
        testmsg === "PDF" ||
        testmsg === "tiff" ||
        testmsg === "TIFF" ||
        testmsg === "swf" ||
        testmsg === "SWF" ||
        testmsg === "bmp" ||
        testmsg === "gif" ||
        testmsg === "jpeg" ||
        testmsg === "jpe" ||
        testmsg === "rar" ||
        testmsg === "RAR" ||
        testmsg === "zip" ||
        testmsg === "7z" ||
        testmsg === "lzh" ||
        testmsg === "LZH";
      if (!isLt50) {
        this.uploadLoading = false;
        this.$message({
          message: "文件大小不可超过50M！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("文件大小不可超过50M！");
      }
      //是否有后缀
      let fileType = file.name.indexOf(".") != -1;
      if (!extension && fileType) {
        this.uploadLoading = false;
        this.$message({
          message: "上传文件格式错误！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
        // this.$showErrorMessage("上传文件格式错误！");
      }
      return isLt50 && (extension || !fileType);
    },
    download(index, row) {
      let openUrl = document.createElement("a");
      openUrl.style.display = "none";
      openUrl.href = `${addUrlPerFix(
        process.env.VUE_APP_BASE_URL
      )}/apis/bid/oss/downloadByUploadId?fileUrl=${
        row.fileUrl
      }&fileName=${encodeURIComponent(row.fileName)}`;
      console.log(openUrl.href);
      openUrl.setAttribute("download", row.fileName);
      document.body.appendChild(openUrl);
      openUrl.click();
    },
    deleteRow(index, row) {
      if (row.fileinfoId) {
        this.deletePlanAttachementList.push(row.fileinfoId);
      }
      delFileInfo({
        delFileInfoBOs: [
          {
            uploadId: row.uploadId,
            fileinfoId: row.fileinfoId
          }
        ]
      }).then(res => {});
      this.fileTableData.splice(index, 1);
    },
    //预览
    preview({ uploadId }) {
      getPreviewUrl(uploadId);
      // const previewSrc = getPreviewUrl(fileUrl);
      // window.open(previewSrc);
    }
  },
  mounted() {
    console.log(this.fileTableData);
  }
};
</script>

<style lang="scss" scoped>
.operate {
  float: right;
}
/deep/ {
  .el-input input {
    padding-right: 60px;
  }
}
.overFlow_txt {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}
</style>
